import { Skeleton } from "@material-ui/lab";

const SkeletonLoading = ({ children, isDataLoading, size = {}, variant }) => {

    if (!isDataLoading)
        return children || null;

    const defaultWidth = variant === 'rect' || !size.width ? '100%' : 100;

    return (
        <Skeleton height={size.height || 20} width={size.width || defaultWidth} variant={variant} />
    )
}

export default SkeletonLoading;
